import { type ChangeEvent, useCallback, useMemo, useState } from 'react';
import { debounce } from '../fn/debounce';

export function useSearch(initialValue?: string) {
  const [realTimeSearchValue, setRealTimeSearchValue] = useState(initialValue ?? '');
  const [searchValue, setSearchValue] = useState(initialValue ?? '');

  const debouncedSetSearchValue = useMemo(() => debounce(setSearchValue, 250), []);

  const handleSetSearchValue = useCallback(
    (value: string) => {
      setRealTimeSearchValue(value);
      debouncedSetSearchValue(value);
    },
    [debouncedSetSearchValue],
  );

  const onSearchChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setRealTimeSearchValue(event.target.value);
      debouncedSetSearchValue(event.target.value);
    },
    [debouncedSetSearchValue],
  );

  return { realTimeSearchValue, searchValue, setSearchValue: handleSetSearchValue, onSearchChange };
}
